import { LogoMark } from "@shared/components/Logo";
import {
	CONTACT_EMAIL,
	GUIDE_LINKS,
	MARKET_LINKS,
	NAV_LINKS,
	type NavLink,
	WHATSAPP_URL,
} from "../site";

const COLUMNS: {
	title: string;
	links: (NavLink & { external?: boolean })[];
}[] = [
	{
		title: "Product",
		links: [
			...NAV_LINKS,
			{
				label: "Arabic chatbot for ecommerce",
				href: "/arabic-chatbot-for-ecommerce",
			},
			{ label: "Book a demo", href: "/demo" },
		],
	},
	{ title: "Guides", links: GUIDE_LINKS },
	{ title: "Markets", links: MARKET_LINKS },
	{
		title: "Company",
		links: [
			{ label: "Hephon", href: "https://hephon.ai", external: true },
			{ label: CONTACT_EMAIL, href: `mailto:${CONTACT_EMAIL}` },
			{ label: "WhatsApp", href: WHATSAPP_URL, external: true },
			{ label: "Sign in", href: "/login" },
		],
	},
	{
		title: "Legal",
		links: [
			{ label: "Privacy", href: "/legal/privacy" },
			{ label: "Terms", href: "/legal/terms" },
			{ label: "Data processing", href: "/legal/dpa" },
			{ label: "Subprocessors", href: "/legal/subprocessors" },
		],
	},
];

/** Small type on the page's grey, the way a long page ends. */
export function MarketingFooter() {
	return (
		<footer className="bg-(--mk-mist) text-[13px] text-(--mk-muted)">
			<div className="mk-container grid grid-cols-2 gap-10 py-14 sm:grid-cols-3 lg:grid-cols-[1.4fr_repeat(5,1fr)]">
				<div className="col-span-2 sm:col-span-3 lg:col-span-1">
					<a
						href="/"
						className="inline-flex items-center gap-2 font-semibold text-(--mk-ink) text-[15px] tracking-[-0.02em]"
					>
						<LogoMark className="size-6" />
						Hephon Commerce
					</a>
					<p className="mt-3 max-w-xs leading-relaxed">
						The AI shopping assistant for supermarkets and
						retailers, in your app, on WhatsApp and on the phone.
					</p>
				</div>
				{COLUMNS.map((column) => (
					<nav key={column.title} aria-label={column.title}>
						<p className="font-semibold text-(--mk-ink)">
							{column.title}
						</p>
						<ul className="mt-3 space-y-2">
							{column.links.map((link) => (
								<li key={link.href}>
									<a
										href={link.href}
										{...(link.external
											? {
													target: "_blank",
													rel: "noopener",
												}
											: {})}
										className="hover:text-(--mk-ink) hover:underline hover:underline-offset-4"
									>
										{link.label}
									</a>
								</li>
							))}
						</ul>
					</nav>
				))}
			</div>
			<div className="mk-container border-(--mk-line) border-t py-6">
				<p>
					© {new Date().getFullYear()} Hephon L.L.C-FZ, Dubai, United
					Arab Emirates.
				</p>
			</div>
		</footer>
	);
}
